// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    SERVER_ORIGIN: '',
    production: false,
    useHash: false,
    hmr: false,
    // Local development: everything, including debug tracing.
    logLevel: 'debug',
     //apiRoot: window.location.origin + '/' + "consoleV2" + '/',
    // apiRoot: window.location.origin + '/' + "deckorate-console" + '/',
    //apiRoot: window.location.origin + '/',
    apiRoot:"https://api.deckorate.williamslea.ai/",
    

    application: {
        name: 'DeckorateConsole',
        caption: 'DeckorateConsole',
        version: '1.0.1',
        logo: './assets/images/rrd_logo_blue.svg',
        sessionTimeout: 20,
        applicationId: 17,
        secureKey: 'LoftTheme_798e8678-0188-4ccf-8d9c-cf0d19124f87',
        qCPageAutoRefresh: (1 * 60000),
    },

    API: {
        Dashboard: "api/Dashboard"
    },
    defaultImage: './assets/images/placeholder-upload.png',
    defaultAvatar: './assets/images/user.jpg',
    defaultDateFormat: 'MMM d, y, hh:mm',
    profile: {
        isAnonymous: false,
        guestName: 'Guest User',
        guestAvatar: './assets/images/user.jpg',
    },
    pagination: {
        defaultLayout: 'card',
        table: {
            pageSize: 10,
            pageSizeValues: [10, 25, 50, 100],
        },
        cards: {
            pageSize: 12,
            pageSizeValues: [12, 24, 48, 96],
        },
    },
    signalR: {
        enabled: false,
        connectionPath: 'notify',
    },
    documentRefreshInterval: 10000
   
};

















